'use strict';

module.exports = 60 * 1000;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/var/MINUTES.js
// module id = 96
// module chunks = 0